export enum QuestionType {
  MultipleChoice = 1,
  Checkbox = 2,
  TrueFalse = 3,
  FillInBlanks = 4,
  Essay = 5,
  Matching = 6,
  UploadDocument = 7,
}

